module.exports = __webpack_public_path__ + "static/media/DJI_0379.9070a537.MP4";